import { IApplicationState, TCardId } from '../../../../../../types/types';

export const getEditedNameCardId = (
    state: IApplicationState
): TCardId => {
    return state.kanbanView.editedNameCardId;
};
